module.exports = __webpack_public_path__ + "assets/canva-icon.fe125fd3.svg";